import { OrderType } from '@/shared/constants/commonTypes';
import { IonSelect, IonSelectOption } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import styles from './OrderTypeDropdown.module.css';

type Props = {
  disabled?: boolean;
  orderType: string;
  setOrderType: (string) => void;
};

const OrderTypeDropdown: React.FC<Props> = ({ disabled, orderType, setOrderType }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.dropdown}>
      <IonSelect
        disabled={disabled}
        interface="popover"
        fill="outline"
        className={styles.dropdownSelect}
        value={orderType}
        onIonChange={(event) => {
          setOrderType(event.detail.value);
        }}
        shape="round"
        justify="space-between"
        mode="md"
      >
        <IonSelectOption className={styles.dropdownOption} value="market">
          {t('trading.buy_sell_form.market_order')}
        </IonSelectOption>
        <IonSelectOption className={styles.dropdownOption} value={OrderType.Limit}>
          {t('trading.buy_sell_form.limit_order')}
        </IonSelectOption>
        <IonSelectOption className={styles.dropdownOption} value={OrderType.StopLimit}>
          {t('trading.buy_sell_form.stop_limit')}
        </IonSelectOption>
        <IonSelectOption className={styles.dropdownOption} value={OrderType.StopMarket}>
          {t('trading.buy_sell_form.stop_market')}
        </IonSelectOption>
      </IonSelect>
    </div>
  );
};

export default OrderTypeDropdown;
